<template>
  <div v-if="source.length">
    <div v-for="(detail, index) in source" :key="index">
      <div v-for="loop in model" :key="loop.id">
        <div v-if="loop.type === 'text'"
          :style="`text-align: ${loop.float === 1 ? 'center' : (loop.float === 2 ? 'right' : 'left')};`">
          {{ replaceVariables(loop, detail, printData) }}
        </div>
        <div v-if="loop.type === 'oneLineText'"
          :style="`text-align: ${loop.float === 1 ? 'center' : (loop.float === 2 ? 'right' : 'left')};`">
          <span v-for="(subItem, subIndex) in loop.value" :key="subIndex">{{ replaceVariables(subItem, detail, printData) }}</span>
        </div>
        <div v-else-if="loop.type === 'dividerConter'"
          :style="`text-align: ${loop.float === 1 ? 'center' : (loop.float === 2 ? 'right' : 'left')};`"
          class="dividerBox">
          <p class="divider"></p>
          <span>{{ replaceVariables(loop, detail, printData) }}</span>
        </div>
        <div v-else-if="loop.type === 'divider'">
          <p class="divider"></p>
        </div>
        <div v-else-if="loop.type === 'textarea'" style="display: flex; justify-content: space-between;">
          <span v-for="(subItem, subIndex) in loop.value" :key="subIndex">
            <span v-if="subItem.isShowIndex && replaceVariables(subItem, detail, printData)">{{ (keyIndex > -1 ? keyIndex : index) + 1 }}.</span>
            {{ replaceVariables(subItem, detail, printData) }}
          </span>
        </div>
        <div v-else-if="loop.type === 'loop'">
          <template v-if="loop.valueType == 'Array'">
            <template v-for="(item, itemIndex) in loop.value">
              <multilayerModelTemplate v-if="(!item.show || (item.show && printData[item.show + 'IsShow'] == 'Y')) && (!item.hide || item.hide && printData[item.hide + 'IsShow'] != 'Y')" :key="itemIndex" :keyIndex="itemIndex" :model="item.model" :source="[source[index][item.source][itemIndex]]" :printData="printData"></multilayerModelTemplate>
            </template>
          </template>
          <template v-else>
            <multilayerModelTemplate v-if="(!loop.value.show || (loop.value.show && printData[loop.value.show + 'IsShow'] == 'Y')) && (!loop.value.hide || loop.value.hide && printData[loop.value.hide + 'IsShow'] != 'Y')" :model="loop.value.model" :source="source[index][loop.value.source]" :printData="printData"></multilayerModelTemplate>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { replaceVariables } from '@/assets/js/appPrint';
export default {
  name: 'multilayerModelTemplate',
  props: {
    printData: Object,
    model: Array,
    source: Array,
    keyIndex: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {

    }
  },
  methods: {
    replaceVariables
  }
}
</script>
<style scoped lang="less">
.flex {
  display: flex;
}

.justify_space-between {
  justify-content: space-between;
}

.center {
  text-align: center;
}

.dividerBox {
  position: relative;

  .divider {
    width: 100%;
    position: absolute;
    top: 50%;
  }

  span {
    background-color: #fff;
    position: relative;
  }
}

.divider {
  height: 1px;
  border-top: 1px dashed #000;
}
</style>